import SimpleBar from 'simpleBar';

const scrollInit = () => {
	const homeTextBlock = document.querySelector('.home-main__text-block');
	const siteTextBlock = document.querySelector('.site-main__text-block');

	if (homeTextBlock) {
		const homeTextBlockScroll = new SimpleBar(homeTextBlock, {autoHide: false});
	}

	if (siteTextBlock) {
		const siteTextBlockScroll = new SimpleBar(siteTextBlock, {autoHide: false});
	}

	document.querySelectorAll('.header__top-results-sites-wrapper').forEach((el) => {
		if (el) {
			const topResultsScroll = new SimpleBar(el, {autoHide: false});
		}
	});

	document.querySelectorAll('.categories-card__sites').forEach((el) => {
		if (el) {
			const sitesScroll = new SimpleBar(el, {autoHide: false});
		}
	});
};

export default scrollInit;
